import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { get, isEmpty } from "lodash";
import { MdNavigateNext } from 'react-icons/md'
import Swal from "sweetalert2";
import { Button, Container, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, InputLabel, Badge, ButtonGroup, Checkbox, FormControlLabel, CircularProgress } from '@mui/material';
import jwt_decode from "jwt-decode";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector, useDispatch } from 'react-redux'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { setEditQuestion, stateValues, stateRefresh } from '../../slices/opinionTradingSlice';
import axios from 'axios'
import moment from 'moment'
import Paper from '@mui/material/Paper';
import Skelton from '../../common/Skelton';
import { ACTIVE_ALL_PREDICTION_SALE, CHECK_TOTAL_TRADES_TRADING, CURRENT_RATE_LIST_TRADE, GET_TRADE_YES_AND_NO, JOIN_SLOT_HOLD, JOIN_TRADE, MAKE_GST_DATA, MOVE_TO_FINISH_TRADE, SALE_TARDE_ACTIVE, TRADE_MANAGE_RATE, TRADING_CANCEL, TRADING_CHANGE_ALL_STATUS, TRADING_CHANGE_STATUS, TRADING_DISTRIBUTE_WINNING, TRADING_FORCE_CANCEL, TRADING_FORCE_CANCEL_ALL, TRADING_HOME_SCREEN, TRADING_LIST, TRADING_WINNING_SET, WINNING_SET_PASSWORD } from '../../constant/endpoint';
import { PREDICTION_TYPE_GST, useStyles } from '../../constant/constant';
import ModalForRate from '../../common/modal';
import FormComponent from '../../components/BotForm';
import { decryptPassword, setTradeRate } from '../../helper';
import PredictionNvigation from '../../components/PredictionNvigation';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '75%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};

const TradingBot = () => {
    const user = useSelector(state => state.loginSlice)
    const { match_id, series_id, sport } = useParams()
    const [trading, setTrading] = React.useState([]);;
    const [Loading, setLoading] = React.useState(true);
    const [showBotModal, setShowBotModal] = React.useState({})
    const [circularLoader, setCircularLoader] = React.useState(false);
    const [joinHold, setJoinHold] = React.useState({})
    const [rate1, setRate1] = React.useState({})
    const [rate2, setRate2] = React.useState({})
    const [ globalJoinSlot,setGlobalJoinSlot] = React.useState("")


    const classes = useStyles();


    const getJoinSlotHold = async () => {
        const response = await axios.get(`${JOIN_SLOT_HOLD}`)
        if (response?.data?.data) {
            setGlobalJoinSlot(response.data.data)  
        }
    }
    useEffect(() => {
        if (isEmpty(trading) && Loading) {
            getOpinionTrading()
            getJoinSlotHold()
        }
    })

    const getOpinionTrading = async () => {
        setLoading(true)
        const response = await axios.get(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id).replace(':sport', sport))
        if (response?.data?.status && !isEmpty(response?.data?.data?.result)) {
            const rateResponse = await axios.get(CURRENT_RATE_LIST_TRADE)
            const parsedData = parseTradeList(response.data.data.result, rateResponse)
            setTrading(parsedData)
        }
        setLoading(false)
    }

    const parseTradeList = (data, rates) => { 
        let currentRateList = rates?.data?.data || [];
        const rateMap = new Map(currentRateList.map(rate => [rate.id, rate]));
    
        let rate1Updates = {};
        let rate2Updates = {};
    
        const filteredData = data
            .reduce((acc, item) => {
                if (item.status !== 1) return acc; // Filter condition
    
                const rateDetail = rateMap.get(item._id);
                if (rateDetail) {
                    rate1Updates[item._id] = { rate01: rateDetail.rate_id1 };
                    rate2Updates[item._id] = { rate02: rateDetail.rate_id2 };
                }
    
                acc.push(item);
                return acc;
            }, [])
            .sort((a, b) =>   (b.sort_number || 0) - (a.sort_number || 0)); // Sorting by sort_number
    
        setRate1(prev => ({ ...prev, ...rate1Updates }));
        setRate2(prev => ({ ...prev, ...rate2Updates }));
    
        return filteredData;
    };
    
    




    
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/bot-matchlist'} >
            <h4>Hold Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>, <h5>{'Trading'}</h5>
    ];
 
 




    const hideBotModal = () => {
        setShowBotModal({})
        getOpinionTrading()
    }

    const holdThePrediction = async (prediction_id, option, joinSlotHold, rate) => {
    
            const requestData = {
                "join_slots": joinHold[prediction_id]?.joinSlotHold ? joinHold[prediction_id]?.joinSlotHold : Number(globalJoinSlot),
                "match_id": match_id,
                "option_id": option,
                "option_name": option == 1 ? "YES" : "NO",
                "prediction_id": prediction_id,
                "slot_fee": Number(rate),
                "sport": 1
            }
            setCircularLoader(true)
            const response = await axios.post(JOIN_TRADE, requestData);
            setCircularLoader(false)
            if (response) {
                Swal.fire(response?.data?.data?.message || "Something Went Wrong")
            }
        
      
    }
    const handleJoinHoldInput = (e, id) => {
        if (e.target.value) {
            setJoinHold(prevValue => ({ ...prevValue, [id]: { joinSlotHold: e.target.value } }))
        }
    }
    const getCurrentRateValue = (rateType,data) => {
        if (rateType === 1) {
            return data?.currentRate?.rate_id1 
        }
        else
            return data?.currentRate?.rate_id2
    }
    const handleRateInput = (e, data) => {
        
        if (e.target.value < data.interval) { e.target.value = data.interval }
        if (e.target.value > (data.rate_id01 + data.rate_id02) - data.interval) { e.target.value = (data.rate_id01 + data.rate_id02) - data.interval}
        if (e.target.value) {
            if (e.target.name === 'rate_id01') {
                setRate1(prevValue => ({ ...prevValue, [data._id]: { rate01: e.target.value } }))
                setRate2(prevValue => ({ ...prevValue, [data._id]: { rate02: Math.abs(10- e.target.value )} }))
            }
            else {
                setRate1(prevValue => ({ ...prevValue, [data._id]: { rate01:  Math.abs(10- e.target.value )} }))
                setRate2(prevValue => ({ ...prevValue, [data._id]: { rate02: e.target.value } }))
            }
        }
    }

    return (
        <>        
            {circularLoader ?
              <Box sx={{
                position: 'fixed',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 9999, // Ensure it stays above other elements
                paddingTop: '20%', // Space from top of the page
            }}>
                    <CircularProgress ></CircularProgress>
                </Box> : ''}
        {!isEmpty(showBotModal) ? <FormComponent data={showBotModal} hideBotModal={hideBotModal} /> : ''}
            <div className="homeCard">
                <div className='subHomeCard'>
                <div >
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                        </Breadcrumbs>
                        <div  style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px"}}>
                            <Button style={{fontSize: "20px"}} onClick={getOpinionTrading}> Refresh</Button>
                        </div>
                   
                    </div>
                  
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                          
                                    <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                        <Table className={classes.table} width="100%" aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                <TableCell>Id</TableCell>
                                                    <TableCell align="left" >Question</TableCell>
                                                 
                                        <TableCell align="center">Hold</TableCell>
                                        <TableCell align="center">Max Slots</TableCell>
                                              
                                                
                                                </TableRow>
                                        </TableHead>
                                      
                                        
                                            <TableBody>
                                                {trading?.filter((data) => !(data.is_finish) && !(data.is_processing)).length > 0 ? trading?.filter((data) => !(data.is_finish) && !(data.is_processing))?.map((data, index) => (
                                                    <TableRow style={{ background: data.shown_on_mobile ? "#e1f2e18a" : "white" }}
                                                        key={data.name}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>

                                                        <TableCell style={{ width: 300 }}>{data.question_english} <hr /> {data.question_hindi}</TableCell>
                                                    
                                                        <TableCell>
                                                            <TextField id="outlined-basic" type='number' size={'small'} style={{ marginRight: "20px" }} variant="outlined" name={'rate_id01'} onChange={(e) => handleRateInput(e, data)}
                                                                value={rate1[data._id]?.rate01 ? rate1[data._id]?.rate01 : data.rate_id01}
                                                                inputProps={{
                                                                    step: data.interval
                                                                }}
                                                                onKeyDown={(e) => {
                                                                        if (e.key !== "ArrowUp" && e.key !== "ArrowDown") {
                                                                          e.preventDefault();
                                                                        }
                                                                      }} 
                                                            />
                                                            
                                                            <Button variant={'contained'} size={"large"} color={data.holdMatching ? 'error' : 'info'} style={{ margin:"0px 20px 20px 0px"}} onClick={() => holdThePrediction(data._id, 1, data.joinSlotHold, rate1[data._id]?.rate01 ? rate1[data._id]?.rate01 : data.rate_id01)} disabled={circularLoader}>YES</Button>
                                                            <TextField id="outlined-basic" type='number' size={'small'} style={{ marginRight: "20px" }} variant="outlined" name={'rate_id02'} onChange={(e) => handleRateInput(e, data)}
                                                                value={rate2[data._id]?.rate02 ? rate2[data._id]?.rate02 : data.rate_id02}
                                                             inputProps={{
                                                                step: data.interval
                                                                }} 
                                                                onKeyDown={(e) => {
                                                                    if (e.key !== "ArrowUp" && e.key !== "ArrowDown") {
                                                                      e.preventDefault();
                                                                    }
                                                                  }} 
                                                            />
                                                            <Button variant={'contained'} size={"large"} color={data.holdMatching ? 'error' : 'warning'} onClick={() => holdThePrediction(data._id, 2, data.joinSlotHold, rate2[data._id]?.rate02 ? rate2[data._id]?.rate02 : data.rate_id02)} disabled={circularLoader}>NO</Button></TableCell>
                                                        <TableCell>
                                                        <TextField id="outlined-basic" type='number' size={'small'} style={{ marginRight: "20px" }} variant="outlined" disabled={true}
                                                                value={globalJoinSlot}
                                    
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell>
                                                </TableRow>}
                                            </TableBody>
                                       
                                        </Table>
                                    </TableContainer>
                               
                        </Box>
                    
                </div>

            </div>

         
            
        </>
    )
}

export default TradingBot